<template>
  <div style="width: 100%; height: 100%">
    <div class="main-content">
      <el-row :gutter="24" class="judge" v-if="$hasMenu('DistrictJudgeModule')">
        <el-col :span="24" style="margin-bottom: 20px; padding-left: 0">
          <span class="judge-title">综合评价</span>
        </el-col>
        <el-col :span="24">
          <el-row :gutter="24" type="flex" justify="space-between">
            <el-col
              :span="7"
              class="primary-col"
              v-for="(item, index) in schoolStage"
              :key="item.value"
              :style="{
                background: 'url(' + backUrl[index] + ') no-repeat right'
              }"
            >
              <div class="item">
                <p class="title">
                  {{
                    '评价指标' +
                      '（' +
                      _.filter(grades, { value: item.value })[0].name +
                      '）'
                  }}
                </p>
                <p class="view" @click="view(item)">
                  评价指标{{
                    item.value === 1 ? '' : ''
                  }}、评价设置、历史指标
                </p>
                <p class="update">
                  <span
                    style="display: block; margin-bottom: 5px; min-height: 16px"
                  >
                    <span
                      style="
                        display: inline-block;
                        width: 60px;
                        vertical-align: top;
                      "
                      >已存档：</span
                    >
                    <span
                      v-if="
                        item.filedSchoolYears &&
                          item.filedSchoolYears.length > 0
                      "
                      class="wrap"
                    >
                      <span
                        v-for="(year, index) in item.filedSchoolYears"
                        :key="year + 'filed'"
                        >{{ year }}级<span
                          v-if="
                            (index === 0 && item.filedSchoolYears.length > 1) ||
                              index !== item.filedSchoolYears.length - 1
                          "
                          >/</span
                        ></span
                      ></span
                    ><span v-else>无</span></span
                  >
                  <span style="display: block; min-height: 16px"
                    ><span
                      style="
                        display: inline-block;
                        width: 60px;
                        vertical-align: top;
                      "
                      >未存档：</span
                    >
                    <span
                      v-if="
                        item.notFiledSchoolYears &&
                          item.notFiledSchoolYears.length > 0
                      "
                      class="wrap"
                    >
                      <span
                        v-for="(year, index) in item.notFiledSchoolYears"
                        :key="year + 'noFiled'"
                        >{{ year }}级<span
                          v-if="
                            (index === 0 &&
                              item.notFiledSchoolYears.length > 1) ||
                              index !== item.notFiledSchoolYears.length - 1
                          "
                          >/</span
                        ></span
                      ></span
                    ><span v-else>无</span></span
                  >
                </p>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row
        :gutter="24"
        class="report"
        v-if="$hasMenu('DistrictReportModule') && !$regional.HengshuiYanshou"
      >
        <el-col :span="24" style="margin-bottom: 20px; padding-left: 0">
          <span class="judge-title">素质报告</span>
        </el-col>
        <el-col :span="24">
          <el-row :gutter="24" type="flex" justify="space-between">
            <el-col :span="7" class="primary-report">
              <div class="item">
                <p class="title">报告模板（小学）</p>
                <p class="view" @click="viewTemplate(1)">模版查看</p>
              </div>
            </el-col>
            <el-col :span="7" class="junior-report">
              <div class="item">
                <p class="title">报告模板（初中）</p>
                <p class="view" @click="viewTemplate(2)">模版查看</p>
              </div>
            </el-col>
            <el-col :span="7" class="high-report">
              <div class="item">
                <p class="title">报告模板（高中）</p>
                <p class="view" @click="viewTemplate(3)">模版查看</p>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import SecondNavBar from '@/components/common/SecondNavBar'
export default {
  props: [],

  components: {
    'second-nav-bar': SecondNavBar
  },

  data () {
    return {
      indicators: [],
      grades: [
        {
          name: '小学',
          value: 1
        },
        {
          name: '初中',
          value: 2
        },
        {
          name: '高中',
          value: 3
        },
        {
          name: '九年一贯',
          value: 4
        }
      ],
      colors: [
        require('../../../assets/primary-standard.png'),
        require('../../../assets/junior-standard.png'),
        require('../../../assets/high-standard.png')
      ],
      backUrl: [],
      schoolStage: [
        {
          name: '小学',
          value: 1
        },
        {
          name: '初中',
          value: 2
        },
        {
          name: '高中',
          value: 3
        }
      ]
    }
  },

  watch: {},

  computed: {
    _ () {
      return _
    }
  },

  mounted () {
    this.initIndicator()
  },

  methods: {
    initIndicator () {
      // 处理背景url
      let temp = []
      let times = Math.ceil(this.schoolStage.length / 3)
      for (let index = 0; index < times; index++) {
        temp.push(this.colors)
      }
      this.backUrl = _.flattenDeep(temp)
      this.$xhrGet(`/eval/indicators/list/gather`).then(rs => {
        for (let index = 0; index < rs.data.length; index++) {
          let element = rs.data[index]
          for (
            let innerIndex = 0;
            innerIndex < this.schoolStage.length;
            innerIndex++
          ) {
            let InnerEle = this.schoolStage[innerIndex]
            if (InnerEle.value === element.schoolStage) {
              this.$set(InnerEle, 'filedSchoolYears', element.filedSchoolYears)
              this.$set(
                InnerEle,
                'notFiledSchoolYears',
                element.notFiledSchoolYears
              )
            }
          }
        }
      })
    },

    view (item) {
      sessionStorage.setItem('plan', JSON.stringify(item))
      if (item.value === 1) {
        this.$router.push({ name: 'DistrictViewPrimaryTarget' })
      } else {
        this.$router.push({ name: 'DistrictViewHigherTarget' })
      }
    },

    viewTemplate (stage) {
      this.$router.push({
        name: 'DistrictViewTemplate',
        query: { stage: stage }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.main-content {
  float: right;
  height: calc(100% - 40px);
  width: calc(100% - 40px);
  padding: 20px;
  box-shadow: 0px 1px 4px 0px inset rgba(0, 0, 0, 0.12);
  position: relative;
  background: var(--theme-background);
}
.judge {
  width: 100%;
  background: #fff;
  padding: 20px;
  margin: 0 0 25px 0 !important;
  border-radius: 4px;
}
.judge-title {
  font-size: 16px;
  font-weight: 500;
  color: #444444;
}
.primary-col {
  padding: 0 !important;
  min-height: 140px;
  width: 360px;
  border-radius: 4px;
  background-size: cover !important;
}
.primary-report {
  padding: 0 !important;
  min-height: 140px;
  width: 360px;
  border-radius: 4px;
  background: url(../../../assets/primary-report.png) no-repeat;
}
.junior-report {
  padding: 0 !important;
  min-height: 140px;
  width: 360px;
  border-radius: 4px;
  background: url(../../../assets/junior-report.png) no-repeat;
}
.high-report {
  padding: 0 !important;
  height: 140px;
  width: 360px;
  border-radius: 4px;
  background: url(../../../assets/high-report.png) no-repeat;
}
.item {
  min-height: 90px;
  padding: 25px 0 25px 62px !important;
}
.title {
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
}
.view {
  margin-top: 15px;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
.update {
  height: auto;
  margin-top: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
}
.report {
  width: 100%;
  background: #fff;
  padding: 20px;
  margin: 0 !important;
  border-radius: 4px;
}
.wrap {
  display: inline-block;
  width: 220px;
  word-wrap: break-all;
  word-break: normal;
  overflow: hidden;
}
.status-span {
  vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/components/district-admin/apply/ApplyManage.vue